import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'
import router from '@/router'

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API || '/admin',
  timeout: 30000
})

service.interceptors.request.use(
  config => {
    const token = getToken()
    if (token) {
      config.headers['Authorization'] = token
    }
    return config
  },
  error => Promise.reject(error)
)

service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code !== 1) {
      Message.error(res.msg || '请求失败')
      if (res.code === 401) {
        MessageBox.confirm('登录已过期，请重新登录', '提示', {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          store.dispatch('user/resetToken').then(() => {
            router.push('/login')
          })
        })
      }
      return Promise.reject(new Error(res.msg || '请求失败'))
    }
    return res
  },
  error => {
    Message.error(error.message || '网络错误')
    return Promise.reject(error)
  }
)

export default service

export function toFormData(data, prefix = '') {
  const form = new FormData()
  appendFormData(form, data, prefix)
  return form
}

function appendFormData(form, data, prefix = '') {
  Object.keys(data).forEach(key => {
    const val = data[key]
    if (val === undefined || val === null) return
    const fullKey = prefix ? `${prefix}[${key}]` : key
    if (typeof val === 'object' && !Array.isArray(val)) {
      appendFormData(form, val, fullKey)
    } else if (Array.isArray(val)) {
      val.forEach((item, index) => {
        form.append(`${fullKey}[${index}]`, item)
      })
    } else {
      form.append(fullKey, val)
    }
  })
}
